/**
 * Cart Terms Language
 * -------------------
 * Traduit le texte d'acceptation des CGV de l'app (élément `.rale-message`) selon la langue,
 * dans le panier ET le drawer. L'élément est injecté par l'app de façon asynchrone et re-rendu
 * au morph du drawer/panier → on réapplique via cart:update + MutationObserver (débouncé).
 */
(function () {
  if (window.__cartTermsLangInit) return;
  window.__cartTermsLangInit = true;

  var termsLinks = {
    fr: 'https://www.annickgoutal.com/policies/terms-of-sale',
    en: 'https://www.annickgoutal.com/en/policies/terms-of-sale'
  };

  var messages = {
    fr: 'Je confirme avoir lu et accepté les <a href="' + termsLinks.fr + '" target="_blank" class="rale-link">Conditions générales de vente.</a>',
    en: 'I accept and agree to the <a href="' + termsLinks.en + '" target="_blank" class="rale-link">terms of sale.</a>'
  };

  function baseLang() {
    var path = window.location.pathname.toLowerCase();
    if (path.indexOf('/fr') === 0) return 'fr';
    if (path.indexOf('/en') === 0) return 'en';
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.split('-')[0] || 'en';
  }

  function apply() {
    var lang = baseLang();
    var html = messages[lang] || messages.en;
    var nodes = document.querySelectorAll('.rale-message');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      // Déjà traduit dans cette langue → on ne retouche pas (évite toute boucle avec l'observer).
      if (el.dataset.langApplied === lang) continue;
      el.innerHTML = html;
      el.dataset.langApplied = lang;
    }
  }

  // Débounce : l'observer et les re-render génèrent beaucoup de mutations.
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      apply();
    }, 100);
  }

  // Injection async de l'app + re-render du drawer/panier → on observe le DOM.
  var observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('cart:update', schedule);

  if (document.readyState !== 'loading') apply();
  else document.addEventListener('DOMContentLoaded', apply);
})();
